import React from 'react';
import { WorkflowHistoryEntry } from '../../../services/legacyApi';

type StatusHistoryPanelProps = {
    history: WorkflowHistoryEntry[];
};

export const StatusHistoryPanel: React.FC<StatusHistoryPanelProps> = ({ history }) => {
    if (!history.length) {
        return <p className="text-sm text-muted-foreground">No status changes recorded yet.</p>;
    }

    return (
        <div className="space-y-2">
            {history.map((entry) => (
                <div key={entry.log_id} className="rounded-md border bg-white p-3">
                    <div className="text-sm font-medium text-foreground">
                        {entry.event_label || entry.event_code || 'Status Updated'}
                    </div>
                    <div className="text-xs text-muted-foreground">
                        {entry.old_status_name} {'->'} {entry.new_status_name}
                    </div>
                    {entry.reason ? <div className="text-xs text-muted-foreground">Reason: {entry.reason}</div> : null}
                    {entry.created_at ? (
                        <div className="text-xs text-muted-foreground">
                            {new Date(entry.created_at).toLocaleString()}
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
};
